var module = angular.module('octopusApp.environments');

module.directive('azureWebSiteSelectorDeprecated', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            endpoint: '='
        },
        templateUrl: 'areas/environments/views/endpoints/azure_web_site_selector.html',
        controllerAs: 'vm',
        bindToController: true,
        controller: function ($scope, octopusRepository, busy) {
            var vm = this;
            vm.isLoading = busy.create();
            vm.changed = changed;

            function changed() {
                if (vm.selectedWebApp) {
                    vm.endpoint.WebSpaceName = vm.selectedWebApp.WebSpace;
                    vm.endpoint.WebAppName = vm.selectedWebApp.Name;
                } else {
                    vm.endpoint.WebSpaceName = null;
                    vm.endpoint.WebAppName = null;
                }
            }

            $scope.$watch(function () {
                    return vm.endpoint.AccountId;
                },
                function () {
                    if(!vm.endpoint.AccountId){
                        vm.webSites = [];
                        vm.selectedWebApp = null;
                    } else {
                        vm.isLoading.promise(octopusRepository.Accounts.get(vm.endpoint.AccountId)
                            .then(function (account) {
                                return octopusRepository.Accounts.getWebSites(account)
                                        .then(function (webSites) {
                                            vm.webSites = webSites;

                                            if (vm.endpoint.WebAppName) {
                                                vm.selectedWebApp = webSites.filter(function (website) {
                                                    return website.Name === vm.endpoint.WebAppName;
                                                })[0];
                                            }
                                        });
                            })
                        );
                    }
                }
            );
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/directives/endpoints/azure_web_site_selector.js
// module id = 6510969757192372
// module chunks = 1